var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('div',[_c('div',{staticClass:"pa-6"},[_c('h2',{staticClass:"mb-4"},[_vm._v("AMT")]),_c('Testen',{attrs:{"tests":_vm.amttests,"data":_vm.data,"current-hardware-id":"AMT"}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }